var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",class:_vm.$mq,attrs:{"src":"/img/logo.png","alt":_vm.$t('main.appName')}})}
var staticRenderFns = []

export { render, staticRenderFns }